import styled from 'styled-components'
import fonts from '../../tokens/fonts'
import { composeTheme } from '../../utils/compose-theme'

export const TagWapper = styled.div.attrs((props) => composeTheme(props))`
  align-items: center;
  border-radius: ${(props) => props.theme.tag.borderRadius};
  display: flex;
  width: fit-content;
  cursor: default;
  margin: 0 1rem;
  border: 0.2rem solid;
  font-family: ${fonts.inter};
  font-style: normal;
  font-weight: ${(props) => props.theme.tag.fontWeight};
  letter-spacing: 0;
  line-height: ${(props) => props.theme.tag.lineHeight};

  > * {
    margin: ${(props) => props.theme.tag.gap};
  }

  > *:first-child {
    margin-left: 0;
  }

  > *:last-child {
    margin-right: 0;
  }

  &.theme {
    &-enabled {
      border-color: ${(props) => props.theme.tag.enabledBorderColor};
      background-color: ${(props) => props.theme.tag.enabledBackgroundColor};
      color: ${(props) => props.theme.tag.enabledColor};

      svg {
        color: ${(props) => props.theme.tag.enabledIconColor};
        height: ${(props) => props.theme.tag.iconSize};
      }
    }

    &-active {
      border-color: ${(props) => props.theme.tag.activeBorderColor};
      background-color: ${(props) => props.theme.tag.activeBackgroundColor};
      color: ${(props) => props.theme.tag.activeColor};

      svg {
        color: ${(props) => props.theme.tag.activeIconColor};
        height: ${(props) => props.theme.tag.iconSize};
      }
    }

    &-disabled {
      border-color: ${(props) => props.theme.tag.disabledBorderColor};
      background-color: ${(props) => props.theme.tag.disabledBackgroundColor};
      color: ${(props) => props.theme.tag.disabledColor};

      svg {
        color: ${(props) => props.theme.tag.disabledIconColor};
        height: ${(props) => props.theme.tag.iconSize};
      }
    }

    &-negative {
      border-color: ${(props) => props.theme.tag.negativeBorderColor};
      background-color: ${(props) => props.theme.tag.negativeBackgroundColor};
      color: ${(props) => props.theme.tag.negativeColor};

      svg {
        color: ${(props) => props.theme.tag.negativeIconColor};
        height: ${(props) => props.theme.tag.iconSize};
      }
    }

    &-positive {
      border-color: ${(props) => props.theme.tag.positiveBorderColor};
      background-color: ${(props) => props.theme.tag.positiveBackgroundColor};
      color: ${(props) => props.theme.tag.positiveColor};

      svg {
        color: ${(props) => props.theme.tag.positiveIconColor};
        height: ${(props) => props.theme.tag.iconSize};
      }
    }
  }

  &.size {
    &-small {
      font-size: 1.4rem;
      padding: 0.3rem 1.2rem;
    }

    &-medium {
      font-size: ${(props) => props.theme.tag.fontSize};
      padding: ${(props) => props.theme.tag.padding};
    }

    &-large {
      font-size: 1.6rem;
      padding: 0.8rem 1.2rem;
    }
  }
`

export const ButtonRemove = styled.button`
  align-items: center;
  background-color: transparent;
  border-color: transparent;
  border-radius: 1em;
  border-width: 0;
  color: inherit;
  cursor: pointer;
  display: flex;
  height: 1em;
  justify-content: center;
  letter-spacing: normal;
  padding: 0;
  text-transform: none;
  width: 1em;

  &:hover {
    background-color: rgba(200, 200, 200, 0.5);
  }

  &:focus {
    outline: none;
  }

  &:disabled {
    background-color: transparent;
    cursor: not-allowed;
  }
`
